import {apiService} from '../apiService';
import type {ApproveBookingRequest, Booking, UpdateBookingRequest} from 'shared-types';

export const bookingApi = {
    // GET routes
    getAll: (): Promise<Booking[]> =>
        apiService.get('/book/getAllBooking'),

    getById: (id: string): Promise<Booking> =>
        apiService.get(`/book/getBookingById/${id}`),

    getByEventId: (eventId: string): Promise<Booking> =>
        apiService.get(`/book/getBookingByEventId/${eventId}`),

    getAllByCalendar: (calendarId: string): Promise<Booking[]> =>
        apiService.get(`/googleCalendarBookingIntegration/all/${calendarId}`),

    getByRoomId: (roomId: string): Promise<Booking[]> =>
        apiService.get(`/book/room/${roomId}`),

    // POST routes
    create: (booking: Partial<Booking>): Promise<Booking> =>
        apiService.post('/book', booking),

    // PATCH/PUT routes
    update: (id: string, booking: UpdateBookingRequest | Partial<Booking>): Promise<Booking> =>
        apiService.patch(`/book/updateBooking/${id}`, booking),

    approve: (id: string, data: ApproveBookingRequest): Promise<Booking> =>
        apiService.put(`/book/bookingApproval/${id}`, data),

    // DELETE routes
    delete: (id: string): Promise<void> =>
        apiService.delete(`/book/deleteBooking/${id}`),
};